"use client";

import { useEffect } from "react";

const SCROLLED_CLASS = "nitro-public-scrolled";

export function StickyPublicState() {
  useEffect(() => {
    const root = document.documentElement;

    function updateScrollState() {
      root.classList.toggle(SCROLLED_CLASS, window.scrollY > 32);
    }

    updateScrollState();
    window.addEventListener("scroll", updateScrollState, { passive: true });

    return () => {
      window.removeEventListener("scroll", updateScrollState);
      root.classList.remove(SCROLLED_CLASS);
    };
  }, []);

  return null;
}
